import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../../../core-video-internal';
import { DevicePlatform } from './common.enums';
export { DevicePlatform } from './common.enums';
var AdExtensionMarkedUnifiedId = 'MarketUnifiedAdId';
export function isLiveMetadata(reportingMetadata) {
    return !!reportingMetadata && 'channelId' in reportingMetadata && 'channelName' in reportingMetadata;
}
export function isVodMetadata(reportingMetadata) {
    return !!reportingMetadata && 'id' in reportingMetadata;
}
export function hasEpisodeMetadata(reportingMetadata) {
    var epMetadata = reportingMetadata;
    return Boolean(epMetadata && epMetadata.episodeNumber && epMetadata.seasonNumber);
}
export function addMarketUnifiedAdId(extensions) {
    extensions === null || extensions === void 0 ? void 0 : extensions.forEach(function(ext) {
        var _ext_programmatic_find, _ext_programmatic;
        ext.marketUnifiedAdID = ((_ext_programmatic = ext.programmatic) === null || _ext_programmatic === void 0 ? void 0 : (_ext_programmatic_find = _ext_programmatic.find(function(node) {
            return node.name === AdExtensionMarkedUnifiedId;
        })) === null || _ext_programmatic_find === void 0 ? void 0 : _ext_programmatic_find.value) || 'NA';
    });
    return extensions;
}
export function getDevicePlatform() {
    var deviceType = CoreVideoInternal.deviceType, deviceBrand = CoreVideoInternal.deviceInfo.deviceBrand;
    var brandToPlatform = {
        Amazon: DevicePlatform.FIRETV,
        Comcast: DevicePlatform.XFINITY,
        Chromecast: DevicePlatform.CHROMECAST,
        Hisense: DevicePlatform.HISENSE,
        LG: DevicePlatform.LG,
        PlayStation: DevicePlatform.PLAYSTATION,
        Samsung: DevicePlatform.SAMSUNG,
        Xbox: DevicePlatform.XBOX,
        YouView: DevicePlatform.SETTOPBOX,
        Meta: DevicePlatform.QUEST
    };
    var deviceHeaders;
    switch(deviceType){
        case DeviceType.Android:
            deviceHeaders = brandToPlatform[deviceBrand] || DevicePlatform.ANDROIDTV;
            break;
        case DeviceType.Browser:
            deviceHeaders = DevicePlatform.WEB;
            break;
        case DeviceType.MultiChoiceRdk:
        case DeviceType.OneSdk:
        case DeviceType.Kpn:
            deviceHeaders = DevicePlatform.RDK;
            break;
        default:
            deviceHeaders = brandToPlatform[deviceBrand];
    }
    return deviceHeaders;
}

//# sourceMappingURL=common-metadata-helper.js.map